import React from 'react';
import Skyscraper, { types } from './skyscraper';

WideSkyscraper.propTypes = Skyscraper.propTypes;

export default function WideSkyscraper(props) {
  return <Skyscraper {...props} type={types.WIDE} />;
}
